{
  "手机号登录": "Phone login",
  "手机号验证码": "SMS code",
  "短信验证码": "SMS code",
  "获取验证码": "Send code",
  "验证码发送请求已提交": "Verification code requested",
  "手机号已绑定": "Phone number linked",
  "验证并绑定": "Verify and link",
  "请使用安全设置中已绑定的手机号": "Use the phone number linked in security settings",
  "登录手机号": "Login phone number",
  "绑定手机号": "Link phone number",
  "通用验证码模板编号": "General verification template ID",
  "短信登录未启用，请联系管理员": "SMS login is disabled. Contact your administrator.",
  "短信发送过于频繁，请稍后重试": "Too many SMS requests. Try again later.",
  "短信发送失败，请稍后重试": "Could not send SMS. Try again later.",
  "请先在安全设置中绑定手机号": "Link a phone number in security settings first.",
  "该手机号未注册或未绑定": "This phone number is not registered or linked to an account.",
  "手机号已被其他账号绑定": "This phone number is linked to another account.",
  "验证码无效或已使用，请重新获取": "Code invalid or already used. Request a new code.",
  "请输入已绑定的手机号": "Enter your linked phone number",
  "手机号找回": "Recover by phone",
  "邮箱找回": "Recover by email",
  "验证账号后设置新密码": "Verify your account to set a new password",
  "若该手机号已绑定账号，验证码将通过短信发送": "If this phone number is linked to an account, a verification code will be sent by SMS.",
  "找回密码专用模板编号": "Password reset template override",
  "短信找回密码未启用，请联系管理员": "SMS password recovery is disabled. Contact your administrator."
}
